import { request } from '@/shared/api/request'

export const generateRecoverXml = (payload) => {
	return request({ url: 'contract/restore/xml', method: 'POST', data: payload })
}

export const recoverXml = (payload) => {
	return request({ url: 'contract/sendRestorationData', method: 'POST', data: payload })
}
